"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavBar = exports.MENUBAR_ID = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react2 = require("@floating-ui/react");
var _Button = require("design_system/Button");
var _I18n = require("design_system/I18n");
var _Icon = require("design_system/Icon");
var _useResizeObserver = require("design_system/hooks/useResizeObserver");
var _useSlideTransition = require("design_system/hooks/useSlideTransition");
var _NavBarContext = require("./NavBarContext");
var _NavBarLink = require("./NavBarLink");
var _NavBarMenu = require("./NavBarMenu");
var _NavBarMenuButton = require("./NavBarMenuButton");
var _NavBarMenuItems = require("./NavBarMenuItems");
var _NavBarMenuItem = require("./NavBarMenuItem");
var _Layout = require("design_system/Layout");
var _NavBarLogo = require("./NavBarLogo");
var _TopBar = require("./TopBar");
var _NavContainer = require("./NavContainer");
var _NotificationDot = require("./NotificationDot");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const MENUBAR_ID = "navbar1";
exports.MENUBAR_ID = MENUBAR_ID;
const THEME = {
  container: {
    position: "s768:flex flex-col s768:items-center s768:flex-row s768:flex-none overflow-auto s768:overflow-hidden",
    bg: "s768:bg-white",
    h: "s768:h-88",
    border: "border-gray-e7e9ef border-b-1 s768:border-solid border-none",
    shadow: "s768:shadow-0-2-2-0-000-15"
  },
  iconsContainer: {
    position: "flex flex-shrink-1 items-center justify-between z-10",
    bg: "bg-white",
    h: "h-64 s768:h-auto",
    w: "w-full s768:w-auto",
    border: "border-gray-e7e9ef border-b-1 border-solid s768:border-none",
    shadow: "shadow-0-2-2-0-000-15 s768:shadow-none"
  },
  menuIconButton: {
    position: "flex s768:hidden",
    m: "mr-16 s768:m-0"
  },
  itemsContainer: {
    position: "s768:flex flex-col flex-shrink-0 s768:flex-row overflow-auto s768:overflow-hidden",
    w: "w-full s768:w-auto",
    bg: "bg-white"
  },
  notificationDot: {
    position: "border-2 rounded-full h-12 w-12 -ml-6 mb-32 s768:hidden",
    bg: "bg-primary-3667e9",
    border: "border-white border-2"
  }
};
const NavBarComponent = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    className,
    children,
    menubarId,
    logo,
    showShadow,
    onMenuButtonClick: _onMenuButtonClick,
    menuButtonClassname,
    showNotificationDot,
    ...props
  } = _ref;
  const {
    t
  } = (0, _I18n.useI18nContext)();
  const [open, setOpen] = (0, _react.useState)(false);
  const [width] = (0, _useResizeObserver.useResizeObserver)();
  const isNarrowScreen = width > 0 && width < _useResizeObserver.BREAKPOINTS.s768;
  const {
    ref: transitionRef,
    styles: transitionStyles,
    hidden
  } = (0, _useSlideTransition.useSlideTransition)({
    enabled: isNarrowScreen,
    open
  });
  const mergedRefs = (0, _react2.useMergeRefs)([transitionRef, ref]);
  (0, _react.useEffect)(() => {
    // Close the menu automatically when widening the window
    if (!open || isNarrowScreen) {
      return;
    }
    setOpen(false);
  }, [isNarrowScreen, open]);
  (0, _react.useEffect)(() => {
    const handlePageShow = event => {
      if (event.persisted) {
        setOpen(false);
      }
    };
    window.addEventListener("pageshow", handlePageShow);
    return () => window.removeEventListener("pageshow", handlePageShow);
  }, []);
  const onMenuButtonClick = (0, _react.useCallback)(() => {
    setOpen(prevOpen => {
      _onMenuButtonClick?.(!prevOpen, setOpen);
      return !prevOpen;
    });
  }, [_onMenuButtonClick]);
  return /*#__PURE__*/_react.default.createElement(_NavBarContext.NavBarContext.Provider, {
    value: {
      open,
      setOpen
    }
  }, /*#__PURE__*/_react.default.createElement(_Layout.Box, _extends({
    ref: mergedRefs,
    bg: THEME.container.bg,
    h: THEME.container.h,
    border: THEME.container.border,
    className: (0, _classnames.default)(className, THEME.container.position, {
      [THEME.container.shadow]: showShadow,
      "flex-1": open
    }),
    style: transitionStyles
  }, props), /*#__PURE__*/_react.default.createElement(_Layout.Box, {
    h: THEME.iconsContainer.h,
    w: THEME.iconsContainer.w,
    bg: THEME.iconsContainer.bg,
    border: THEME.iconsContainer.border,
    className: (0, _classnames.default)(THEME.iconsContainer.position, {
      [THEME.iconsContainer.shadow]: showShadow && !open
    })
  }, logo, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(THEME.menuIconButton.position, menuButtonClassname, {
      [THEME.menuIconButton.m]: !showNotificationDot || open
    })
  }, /*#__PURE__*/_react.default.createElement(_Button.IconButton, {
    onClick: onMenuButtonClick,
    icon: open ? /*#__PURE__*/_react.default.createElement(_Icon.X, null) : /*#__PURE__*/_react.default.createElement(_Icon.Menu, null),
    "aria-haspopup": "true",
    "aria-expanded": !isNarrowScreen || open,
    "aria-controls": menubarId,
    "aria-label": open ? t("Close") : t("Menu"),
    hidden: width > _useResizeObserver.BREAKPOINTS.s768
  })), /*#__PURE__*/_react.default.createElement("div", {
    id: "navbar-widget-invalid-or-missing-contact-dot",
    className: (0, _classnames.default)(THEME.notificationDot.position, THEME.notificationDot.bg, THEME.notificationDot.border, {
      "mr-10 s768:m-0": showNotificationDot,
      // width of 12 minus 6 margin left plus 10 = original margin of 16
      hidden: open || !showNotificationDot
    })
  }))), /*#__PURE__*/_react.default.createElement(_Layout.Box, {
    as: "ul",
    id: menubarId,
    role: "menubar",
    w: THEME.itemsContainer.w,
    bg: THEME.itemsContainer.bg,
    className: (0, _classnames.default)(THEME.itemsContainer.position, {
      hidden
    }),
    "aria-orientation": isNarrowScreen ? "vertical" : "horizontal"
  }, children)));
});
NavBarComponent.displayName = "NavBar";
const NavBar = Object.assign(NavBarComponent, {
  Logo: _NavBarLogo.NavBarLogo,
  Link: _NavBarLink.NavBarLink,
  Menu: _NavBarMenu.NavBarMenu,
  MenuButton: _NavBarMenuButton.NavBarMenuButton,
  MenuItems: _NavBarMenuItems.NavBarMenuItems,
  MenuItem: _NavBarMenuItem.NavBarMenuItem,
  TopBar: _TopBar.TopBar,
  Container: _NavContainer.NavContainer,
  NotificationDot: _NotificationDot.NotificationDot
});
exports.NavBar = NavBar;